import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Seo } from "@/components/site/Seo";
import { HomeHero } from "@/components/home/HomeHero";
import { GoogleReviewsStrip } from "@/components/home/GoogleReviewsStrip";
import {
  TreatTheChainSection,
  GoalsSection,
  WhatHurtsSection,
  AudienceSection,
  TestimonialsSection,
  NervousTeaserSection,
  ClosingCTASection,
} from "@/components/home/sections";

export default function Home() {
  const { home, settings } = useSite();
  const [concerns, setConcerns] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/concerns").then((r) => setConcerns(r.data)).catch(() => {});
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  if (!home) return <div className="h-screen bg-ivory" />;

  return (
    <div>
      <Seo title={settings?.seo_title} description={settings?.seo_description} />
      <HomeHero home={home} />
      <GoalsSection home={home} />
      <NervousTeaserSection />
      <AudienceSection />
      <WhatHurtsSection concerns={concerns} />
      <TreatTheChainSection home={home} />
      <TestimonialsSection testimonials={testimonials} />
      <GoogleReviewsStrip />
      <ClosingCTASection home={home} />
    </div>
  );
}
